import React from "react";

import { Plugin, Getter } from "@devexpress/dx-react-core";

interface Props {
  columnNameToIdMap: any;
}

export const SortWithEmpty = ({ columnNameToIdMap }: Props) => {
  return (
    <Plugin
      dependencies={[{ name: "IntegratedSorting" }, { name: "SortingState" }]}
    >
      <Getter
        name="rows"
        computed={(getters) => {
          const rows = getters.rows;
          const sorting = getters.sorting;

          if (sorting.lenght === 0) {
            return rows;
          }

          const sortedColumn = sorting[0];

          const filledRows = rows.filter(
            (row: any) =>
              row.display[columnNameToIdMap[sortedColumn.columnName]] !== "—",
          );

          const rowsWithEmpty = rows.filter(
            (row: any) =>
              row.display[columnNameToIdMap[sortedColumn.columnName]] === "—",
          );

          return sortedColumn.direction === "desc"
            ? [...filledRows, ...rowsWithEmpty]
            : [...rowsWithEmpty, ...filledRows];
        }}
      />
    </Plugin>
  );
};
